/* eslint-disable no-unreachable */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react-hooks/rules-of-hooks */
import React, { useEffect, useState } from 'react';
import { Box, Typography, Button } from '@mui/material';
import { grey } from '@mui/material/colors';

export  function ShowFilesModal({ open, onClose, selectedIdx, ticket }) {
  const [detailModal, setDetailModal] = useState(false);
  const [files, setFiles] = useState(null);

  const handleOnCloseModal = () => {
    // setFiles([])
    onClose()
  }

  const handleOpenDetailModal = () => {
    console.log('open detail modal')
    setDetailModal(true);
  }

  const handleCloseDetailModal = () => {
    setDetailModal(false);
  }

  useEffect(() => {
    if (selectedIdx !== null && ticket)
    setFiles(ticket.data[selectedIdx]);
  })

  return (
    <Box sx={{
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      boxShadow: 24,
      borderRadius: 2,
      backgroundColor: grey[300]
    }}>
      <Box sx={{
        padding: '16px',
        borderRadius: '8px 8px 0 0',
        backgroundColor: '#fff'
      }}>
        <Typography variant="h6" component="h2">
          Anexos
        </Typography>
      </Box>

      {!detailModal &&
        <Box sx={{
          marginTop: '16px',
          marginBottom: '16px',
          marginRight: '32px',
          width: 400,
          minWidth: 400,
          maxHeight: '80%',
          height: '90%',
          width: '100%',
          backgroundColor: '#fff',
          borderRadius: 1,
          display: 'flex',
          flexDirection: 'column',
          padding: 2,
          gap: 2
        }}>
          <Box sx={{
            textAlign: 'center', 
            alignItems: 'center',
            justifyContent: 'center',
          }}>
            {files ?
              <Box
                sx={{
                  width: '100%',
                  maxWidth: '100%',
                  bgcolor: 'background.paper',
                  position: 'relative',
                  overflow: 'auto',
                  maxHeight: 750,
                }}
                subheader={<Box />}
              >
                {files.files.map((item, index) => {
                  return (
                    <Box key={index}
                      sx = {
                        {
                          padding: '10px 0',
                          alignItems: 'center',
                          justifyContent: 'center',
                        }
                      }
                    > 
                      {item.s3key.slice(-3) === 'pdf' 
                        ?
                        <a href={item.signed} target="_blank">
                          <span>{item.s3key.substr(item.s3key.indexOf('-') + 1)}</span>
                        </a>
                        :
                        <a href={item.signed} target="_blank">
                          <img src={item.signed} width="70%" />
                        </a>}
                    </Box>
                  )
                })}
              </Box>
              :
              <Box>
                <span>Não possui anexos.</span>
              </Box>
            }
          </Box>
          
          <Box sx={{
            display: 'flex',
            width: '100%',
            justifyContent: 'flex-end',
            gap: 1
          }}>
            <Button
              color="error"
              variant='contained'
              onClick={handleOnCloseModal}
            >
              Fechar
            </Button>
          </Box>
        </Box>
      }
    </Box>
  )
}
